import React from 'react'

import Tridi from "react-tridi";
import "react-tridi/dist/index.css";

import back from './../../../UI/canvas/carmenu/salir_interior_white.svg'

import { routesData } from './../../../data/ParticularesSpins.data';

class Viewer3D extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            currentZoom: 0.7,
            currentFrame: -1,
            frameWhileChanging: -1,
            updatedSet: [],
            currentColorSelected: 0
        }

        this.tridiRef = React.createRef()
    }

    componentDidMount(){
        this.setState({
            updatedSet: routesData()[0][this.props.individualSelected + " " + this.props.currentColor]
        })
    }

    componentDidUpdate(prevProps){
        console.log(this.props.individualSelected + " " + this.props.currentColor)
        if(prevProps.currentColor !== this.props.currentColor || prevProps.individualSelected !== this.props.individualSelected || prevProps.showSpin !== this.props.showSpin){
            this.setState({
                updatedSet: routesData()[0][this.props.individualSelected + " " + this.props.currentColor]
            }, () => {})
        }
        if(prevProps.individualSelected !== this.props.individualSelected){
            this.setState({
                waitToShow: false
            }, () => {
                this.setState({
                    waitToShow: true
                })
            })
        }
    }

    createColorStructure = () => {
        return(
            <div className='color-container'>
                {
                    this.props.currentColorsArray.map((color, index) => 
                        <div className='color-individual-container' key={index} 
                        onClick= {() => {
                            this.setState({
                                currentColorSelected: index
                            }, () => {this.props.handleChangeColors(index)})
                            
                        }}
                        
                        >
                            <img src={color.Image}/>
                            <div className={this.state.currentColorSelected === index ? "selected-color-round fade-in":"selected-color-round fade-out"}/>
                            <div className='color-name'>{color.NameAlt}</div>
                        </div>
                    )
                }
            </div>
        )
    }

    handleZoom = (payload) => {
        this.setState({
            currentZoom: this.state.currentZoom + payload > 0.8  ? 0.8: this.state.currentZoom + payload < 0.6 ? 0.6: this.state.currentZoom + payload 
        }, () => {
            document.getElementById("viewerImage").style.transform = "scale("+String(this.state.currentZoom)+")"
        })
    }

    handleFrameChange = () => {
    }

    render(){
        return(
            <div className={this.props.showSpin ? 'spin-main fade-in':'spin-main fade-out'}>
                <Tridi 
                    ref={this.tridiRef}
                    location={this.state.updatedSet}
                    dragInterval={1}
                    touchDragInterval={2}
                    format={"webp"}
                    count={60}
                    zoom={this.state.currentZoom}
                    inverse
                    showControlBar={false}
                    mousewheel
                />
                <div className='info-text-car-view'>Da clic en la pantalla y desliza para ver tu vehículo en 360</div>
                <div className='car-view-wrapper'>
                <div className='back-wrapper' onClick={() => {this.props.handleCloseSpin()}}>
                    <img src={back}>
                    </img>
                    <div className='back-text'>
                        Regresar
                    </div>
                </div>
                {
                    this.props.currentColorsArray.length > 0 ?
                    this.createColorStructure():null
                }
                <div className='bike-view-zoom'>
                        <div className='plus' onClick={() => {this.handleZoom(0.1)}}>
                            +
                        </div>
                        <div className='minus' onClick={() => {this.handleZoom(-0.1)}}>
                            -
                        </div>
                </div>
                </div>
            </div>
        )
    }
}

export default Viewer3D